<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索订单号,联系人,手机" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.goods_id"
                placeholder="选择商品"
                allowClear
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in goodsOptions"
                  :value="option.id"
                >{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" allowClear>
                <a-select-option value="1">待付款</a-select-option>
                <a-select-option value="2">待发货/确认</a-select-option>
                <a-select-option value="3">待签收/使用</a-select-option>
                <a-select-option value="4">已完成</a-select-option>
                <a-select-option value="5">售后中</a-select-option>
                <a-select-option value="6">已关闭</a-select-option> 
                <a-select-option value="2.1">待成团</a-select-option> 
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">

            <a-col :md="6" :sm="24">
              <a-form-item label="下单日期">
                <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
            </a-col> 
            
            <a-col :md="6" :sm="24">
              <a-form-item label="分销商结算">
                <a-select v-model="queryParam.cash_id_business" placeholder="请选择" allowClear> 
                  <a-select-option value="1">未结算</a-select-option>
                  <a-select-option value="2">已结算</a-select-option> 
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="供应商结算">
                <a-select v-model="queryParam.fenxiaoStatus" placeholder="请选择" allowClear>  
                  <a-select-option value="1">未结算</a-select-option> 
                  <a-select-option value="2">已结算</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            
            <a-col :md="6" :sm="24">
              <a-form-item label="分销商">
                <a-select
                  showSearch
                  optionFilterProp="title"
                  v-model="queryParam.business_id"
                  placeholder="选择分销商" 
                  allowClear
                >
                  <a-select-option
                    :key="option.id"
                    v-for="option in businessOptions"
                    :title="option.name"
                    :value="option.id"
                  >{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="基地">
                <a-select
                  showSearch
                  optionFilterProp="name"
                  v-model="queryParam.base_id"
                  placeholder="选择基地" 
                  @search="handleSearch"
                  @change="handleChange"
                  allowClear
                >
                  <a-select-option
                    v-for="option in baseOptions"
                    :key="option.id"
                    :value="option.id"
                  >{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="颜色">
                <a-select v-model="queryParam.color" placeholder="请选择" allowClear>
                  <a-select-option value="ff0000">
                    <div style="background: #ff0000; color: #fff; text-align: center">红色</div>
                  </a-select-option>
                  <a-select-option value="FE9A2E">
                    <div style="background: #FE9A2E; color: #fff; text-align: center">橙色</div>
                  </a-select-option>
                  <a-select-option value="FFFF00">
                    <div style="background: #FFFF00; color: #fff; text-align: center">黄色</div>
                  </a-select-option>
                  <a-select-option value="00FF00">
                    <div style="background: #00FF00; color: #fff; text-align: center">绿色</div>
                  </a-select-option>
                  <a-select-option value="01DFD7">
                    <div style="background: #01DFD7; color: #fff; text-align: center">青色</div>
                  </a-select-option>
                  <a-select-option value="0000FF">
                    <div style="background: #0000FF; color: #fff; text-align: center">蓝色</div>
                  </a-select-option>
                  <a-select-option value="8904B1">
                    <div style="background: #8904B1; color: #fff; text-align: center">紫色</div>
                  </a-select-option>
                  <a-select-option value="ccc">
                    <div style="background: #ccc; color: #fff; text-align: center">灰色</div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download('base')" style="margin-left: 8px">
        基地订单下载
        <a-icon type="download" />
      </a-button>
      <a-button @click="download('shop')" style="margin-left: 8px">
        门店订单下载
        <a-icon type="download" />
      </a-button>
      <a-upload
        name="file"
        accept=".csv"
        action
        :before-upload="beforeUpload"
        style="margin-left: 8px"
      >
        <a-button>
          批量发货
          <a-icon type="upload" />
        </a-button>
      </a-upload>
      <!-- <a-upload
        name="file"
        accept=".csv"
        action
        :before-upload="beforeUpload"
        style="margin-left: 8px"
      >
        <a-button>
          批量发货
          <a-icon type="upload" />
        </a-button>
      </a-upload> -->
      <!-- <a-popconfirm
        v-if="selectedRowKeys.length > 0"
        okText="确定"
        cancelText="取消"
        @confirm="setAllStar"
      >
        <span slot="icon" />
        <template slot="title">
          <a-rate style="font-size: 16px;" v-model="setAllStarValue" />
        </template>
        <a-button style="margin:8px  0 0 8px">
          批量标星
          <a-icon type="star" />
        </a-button>
      </a-popconfirm> -->
      <a-popconfirm
        v-if="selectedRowKeys.length > 0"
        okText="确定"
        cancelText="取消"
        @confirm="setAllColor"
      >
        <span slot="icon" />
        <template slot="title">
          <ul style="height:25px;margin:0;padding:0">
            <li
              :style="{'background':'#'+item.value}"
              class="colorItem"
              v-for="(item,i) in colorArr"
              :class="{ borderChange:i==current}"
              :key="i"
              @click="onAllColorHandle(item,i)"
            ></li>
          </ul>
          <br />
          当前选择: {{color_name}}
        </template>
        <a-button style="margin:8px  0 0 8px">
          批量标记
          <a-icon type="bg-colors" />
        </a-button>
      </a-popconfirm>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->

      <!--<a-menu slot="overlay">-->
      <!--<a-menu-item  key="1"> -->
      <!--</a-menu-item>-->
      <!--<a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>-->
      <!--</a-menu>-->
      <!--<a-button style="margin-left: 8px">-->
      <!--批量操作 <a-icon type="down" />-->
      <!--</a-button>-->
      <!--</a-dropdown>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :pageSize="30"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
      <span slot="goods" slot-scope="text,record">
        <div
          style="margin-bottom: 10px;padding-bottom: 10px; border-bottom: 1px solid #eee"
        >订单号 {{record.code}}</div>
        <div
        >
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" />
          <div style="margin-left: 10px; float: left; width: calc(100% - 60px)">
            {{record.title}}
            <br />
            <span style="color: #999">{{record.sku.sku_formart}}</span>
            x {{record.count}}
            <br />
          </div>
          <div class="cf"></div>
        </div>
        <div>
          <a-alert
            style="margin-top:10px; "
            v-if="record.buyer_note"
            :message="'客户备注:'+record.buyer_note"
            type="success"
          />
          <a-alert
            style="margin-top:10px; "
            v-if="record.business_note"
            :message="'商家备注:'+record.business_note"
            type="warning"
          />
          <a-badge :status="record.status_data.class" :text="record.status_data.name" />  
          
          
          <br />
          <a-badge status="processing" v-if="record.fenxiaoStatus==1" text="供应商未结算" />
          <a-badge status="success" v-else text="供应商已结算" /><br/>
          <a-badge status="processing" v-if="record.cash_id_business==0" text="分销商未结算" />
          <a-badge status="success" v-else text="分销商已结算" /><br/>
          <div style="float:left;width:100%">
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setColor(record)">
            <span slot="icon" />
            <template slot="title">
              <ul style="height:25px;margin:0;padding:0">
                <li
                  :style="{'background':'#'+item.value}"
                  class="colorItem"
                  v-for="(item,i) in colorArr"
                  :class="{ borderChange:i==current}"
                  :key="i"
                  @click="onAllColorHandle(item,i)"
                ></li>
              </ul>
              <br />
              当前选择: {{color_name}}
            </template>

            <span v-if="record.color" style="height:25px;line-height:25px;cursor: pointer;">
              已标记
              <span class="colorStar" :style="{'background':'#'+record.color}"></span>
            </span>
            <span v-else>
              未标记
              <span class="colorStar" style="background:#ccc;cursor: pointer;"></span>
            </span>
            <!-- <a-rate style="font-size: 16px; float: right;" disabled v-model="record.star" />
            <div class="cf"></div> -->
          </a-popconfirm>
        </div>
          <span>分销商: {{record.fenxiao_business.name}}</span><br/>
          <span>供应商: {{record.goods_business.name}}</span> 
          <div class="cf"></div>
        </div>
      </span>
      <span slot="buyer" slot-scope="text,record">
        <template>
          <div>
            {{record.buyer_name}}({{record.user_name}})
            <br />
            {{record.buyer_phone}}
            <br />
            <span v-if="record.type=='base'">{{record.address.address}}</span>
          </div>
        </template>mendai
      </span>
      <span slot="price" slot-scope="text,record">
        <template>
          <div>
            <span class="hightlight">{{record.pay_price|price}}</span>元 
            <br />
            <span>供应价 : {{record.fenxiao_price|price}}</span>
            <br />
            <span>利润 : {{record.profit_price|price}}</span>
            <br />
            下单 {{record.create_time|timeFormat}}
            <br />
            付款 {{record.pay_time|timeFormat}}
          </div>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)" v-if="record.type=='base'">物流订单编辑</a>
          <a @click="handleEdit(record)" v-else>门店订单编辑</a>
          <!-- <a-divider type="vertical" /> -->
        </template>
        <!-- <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
            <a  >分销配置</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->
      </span>
    </s-table>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import setting from '@/config/setting'
import UserPicker from '@/components/UserPicker/'
import BasePicker from '@/components/BasePicker/'
import ShopPicker from '@/components/ShopPicker/' 
import qs from 'qs'
import moment from 'moment'

import {
  getOrderList,
  getGoodsOptions,
  setOrderStar,
  expressImport,
  setAllStar,
  getFenxiaoOrderDownloadUrl,
  getFenxiaoOrderList,
  getBusinessOptions,
  getFenxiaoGoodsOptions,
  
} from '@/api/order'
 import { getBusinessAllOptions as getBusinessAllOptions } from '@/api/businessBase'
import { cashOrderList, cashOrder, getDownloadUrl, setCashColor, setAllColor, setCashOrderStar } from '@/api/orderCash'
export default {
  name: 'OrderList',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    UserPicker,
    BasePicker,
    ShopPicker
  },
  data() {
    return {
      baseOptions:[],
      colorShow: false,
      colorSaveLoading: false,
      color_name: '',
      color: '',
      colorItem: '',
      current: '',
      visible: false,
      saveLoading: false,
      businessOptions:[],
      formData: {
        title: '',
        rules: []
      },
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        status: '',
        team_seller_id: undefined,
        seller_user_id: undefined,
        base_id:undefined
      },
      colorArr: [
        { name: '红色', value: 'ff0000' },
        { name: '橙色', value: 'FE9A2E' },
        { name: '黄色', value: 'FFFF00' },
        { name: '绿色', value: '00FF00' },
        { name: '青色', value: '01DFD7' },
        { name: '蓝色', value: '0000FF' },
        { name: '紫色', value: '8904B1' },
        { name: '灰色', value: 'ccc' } 
      ],
      shopFormData:{
        user_id:undefined
      },
      time_range_moment: [],
      goodsOptions: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'order_goods_id',
          width: '50px'
        },
        {
          title: '商品',
          dataIndex: 'goods',
          scopedSlots: { customRender: 'goods' }
        },
        {
          width: '150px',
          title: '买家',
          dataIndex: 'buyer_name',
          scopedSlots: { customRender: 'buyer' }
        },
        {
          title: '价格',
          width: '250px',
          dataIndex: 'pay_price',
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData')
        console.log(this.queryParam)
        this.queryParam.cate_id = 0
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop()
        }
        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

          
        this.queryParam = Object.assign(this.queryParam, parameter)
        return getFenxiaoOrderList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },
      setAllStarValue: 0,
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  computed: {},
  created() {},
  mounted() {
    let that = this
    console.log('query', this.$route.query)
    if (this.$route.query.status) {
      this.queryParam.status = this.$route.query.status + ''
    }
    that.getGoodsOptions()
    that.getBusinessOptions()
  },
  methods: {
    moment,

    handleSearch(value) {
      console.log(value)
      let that = this
      getBusinessAllOptions({ keywords: value }).then(res => {
        console.log(res)
        that.baseOptions = res.data
      })
    },
    handleChange(value) {
      this.formData[this.field] = value
    },
    setColor(record) {
      console.log(record.order_id)
      setCashColor({ id: record.order_goods_id, color: this.color }).then(res => {
        this.$refs.table.refresh(true)
        this.colorItem = ''
      })
    },
    setAllColor() {
      let that = this
      setAllColor({
        ids: this.selectedRowKeys,
        color: this.color
      })
        .then(res => { 
          that.$refs.table.refresh(true)
          that.$message.success('标记成功')
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },
    onAllColorHandle(item, i) {
      this.current = i
      this.color_name = item.name
      this.color = item.value
    },
    getBusinessOptions() {
      let self = this
      getBusinessOptions()
        .then(res => {
          self.businessOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    handleEdit(record) {
      console.log(record)
      if (record.type == 'shop') {
        const { href } = this.$router.resolve({ name: 'FenxiaoShopOrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      } else {
        let { href } = this.$router.resolve({ name: 'FenxiaoOrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(true)
    },
    setAllStatus(status) {
      let self = this
      setGoodsAllStatus({
        ids: self.selectedRowKeys,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(true)
      })
    },
    setStatus(goods_id, status) {
      setGoodsStatus({
        id: goods_id,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(true)
      })
    },
    starChange(record) {
      console.log(record)
      setOrderStar({
        id: record.id,
        star: record.star
      }).then(res => {})
    },
    // 删
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    sellerRewardDone() {
      this.sellerRewardVisible = false
    },
    dealtownRewardDone() {
      this.dealtownRewardVisible = false
    },
    getGoodsOptions() {
      let self = this
      getFenxiaoGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    download(type) {
      getFenxiaoOrderDownloadUrl(Object.assign(this.queryParam, { type: type }))
        .then(res => {
          console.log(res)
          window.open(res.data)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },
    setAllStar() {
      let self = this
      setAllStar({
        ids: self.selectedRowKeys,
        star: self.setAllStarValue
      })
        .then(res => {
          self.$message.success('设置成功')
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    }
  },
  watch: {}
}
</script>

<style scoped>
.borderChange {
  border: 1px solid #000;
}
.colorStar {
  width: 10px;
  height: 10px;
  display: block;
  float: left;
  margin-top: 8px;
  border-radius: 18px;
  cursor: pointer;
}
.colorItem {
  list-style: none;
  float: left;
  width: 40px;
  height: 25px;
  margin-right: 20px;
  cursor: pointer;
}
.colorBox {
  width: 40px;
  height: 25px;
  border: 1px solid #000;
}
</style>